import './SkeletonAvatar-b338b6fd.css';

var classes = {"SkeletonAvatar":"prc-Skeleton-SkeletonAvatar-TYNvX"};

export { classes as default };
